import React from "react";
import { Slider } from "antd";
import { View } from "react-native-web";
import { FrownOutlined, SmileOutlined } from "@ant-design/icons";

export default class IconSlider extends React.Component {
	state = {
		value: 0,
		marks: {},
	};

	componentDidMount() {
		var obj = {};

		for (var i = 1; i <= this.props.max; i++)
			obj[i] = {
				style: { marginTop: 20 },
				label: i,
			};
		this.setState({ marks: obj });
	}

	handleChange = (value) => {
		this.setState({ value });
		this.props.onChange(value);
	};

	render() {
		// const { max, min } = this.props;
		const { value, marks } = this.state;
		// const mid = ((max - min) / 2).toFixed(5);
		// const preColorCls = value >= mid ? "" : "icon-wrapper-active";
		// const nextColorCls = value >= mid ? "icon-wrapper-active" : "";
		return (
			<Slider
				{...this.props}
				onChange={this.handleChange}
				value={this.props.inputvalue || value}
				marks={marks}
				handleStyle={{ height: 30, width: 30, alignSelf: "center" }}
				trackStyle={{ height: 20, borderRadius: 10, marginBottom: 20 }}
				railStyle={{ height: 20, borderRadius: 10, marginBottom: 20 }}
				dotStyle={{ height: 0, width: 0, color: "white" }}
				activeDotStyle={{ height: 0, width: 0 }}
				dots={true}
			/>
		);
	}
}
